import { FLAG_KEYS, useFeatureFlag } from '@zep/feature-flag';

/**
 * Stage 1 UI cohort. spec: docs/specs/generation-mode-experiment-events.md
 * - as_is: dropdown 미노출
 * - dropdown: 생성 모드 split button 노출
 */
export type GenerationModeUiCohort = 'as_is' | 'dropdown';

export const useGenerationModeUiCohort = (): GenerationModeUiCohort => {
  const { enabled } = useFeatureFlag(
    FLAG_KEYS.QUIZ_BUILD_AI_MODEL_SELECT_DROPDOWN.key,
    { bucketBy: 'user' },
  );
  return enabled ? 'dropdown' : 'as_is';
};
